import React, { useEffect, useState } from "react";

// react meta tags
import { ReactTitle } from 'react-meta-tags';

// react redux
import { connect } from "react-redux";

// react router
import { useHistory } from "react-router-dom";

// themes
import { Theme1 } from "./themes";

function Checkout(props) {
    // props
    const {
        globalAppTheme,
        location
    } = props

    // consts
    const history = useHistory();

    // states
    const [userEmail, setUserEmail] = useState("")

    useEffect(() => {
        if (!location?.state?.allowNavigation) {
            history.push("/home")
        } else {
            setUserEmail(location.state.guestEmail) // setting user email
        }
    }, [location, history])

    // userEmail
    // useEffect(() => {
    //     console.log("userEmail ", userEmail);
    // }, [userEmail])

    return (
        <React.Fragment>
            {/* website title */}
            <ReactTitle title={"Checkout | Ruhlistic Decor"} />

            {
                globalAppTheme === 'theme1' ? (
                    <Theme1 guestUserEmail={userEmail} />
                ) : null
            }
        </React.Fragment>
    );
}

const getDataFromStore = (state) => {
    return {
        globalAppTheme: state.common.globalAppTheme,
    };
};

// const dispatchActionsToProps = (dispatch) => {
//     return {};
// };

export default connect(getDataFromStore, null)(Checkout);